import Chart from 'react-google-charts';

export const buildPpgChartDataArray = (values: number[], duration: number) => {
  const result: any[] = values.map((item, index) => {
    const currentDuration = (index * duration) / values.length;
    return [currentDuration, item];
  });
  result.unshift([{ type: 'number', label: 'Time' }, 'Intensity']);
  return result;
};

export const buildPpgChart = (
  values: number[],
  title: string,
  color: string,
  duration: number,
) => {
  const data = buildPpgChartDataArray(values, duration);
  // console.log(data);
  const options = {
    title,
    hAxis: { title: 'Seconds', titleTextStyle: { color: '#333' } },
    // curveType: "function",
    legend: { position: 'bottom' },
    series: {
      0: { color },
    },
  };

  return (
    <Chart
      chartType="LineChart"
      width="100%"
      height="400px"
      data={data}
      options={options}
    />
  );
};

// TODO: move code below to other unit
const emplace = (values: number[][], index: number) => {
  const result: number[] = [];

  const l = values.length;

  for (let i = 0; i < l; i++) {
    result.push(values[i][index]);
  }

  return result;
};

const emplaceTitles = (values: number[][], label: string) => {
  const result: string[] = [];

  for (let i = 0; i < values.length; i++) {
    if (i === 0) {
      result.push(label);
    } else {
      result.push(`${label}.${i}`);
    }
  }

  return result;
};

export const buildMultipleArrays = (values: number[][], duration: number) => {
  const result: any[] = [];

  for (let i = 0; i < values[0].length; i++) {
    const currentDuration = (i * duration) / values[0].length;
    result.push([currentDuration, ...emplace(values, i)]);
  }

  result.unshift([
    { type: 'number', label: 'Time' },
    ...emplaceTitles(values, 'Intensity'),
  ]);

  return result;
};
